export { Flame as default } from './Flame';
